import { useCallback, useEffect, useState } from 'react'
import { loadFromLocal, saveToLocal } from '../lib/utils'

const TUTORIAL_VERSION = 'v2'
const SHOW_DELAY_MS = 500

function getTeamStorageContext() {
  const currentTeam = loadFromLocal('currentTeam')
  const rawTeamId = currentTeam?.id ?? 'guest'
  const teamId = String(rawTeamId).replace(/[^a-zA-Z0-9_-]/g, '_')

  return {
    versionKey: `tutorial_version_${teamId}`,
    seenKey: `tutorial_seen_${teamId}`,
    skipAllKey: `tutorial_skip_all_${teamId}`,
  }
}

export default function useTutorial(pageKey) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!pageKey) {
      setShow(false)
      return
    }

    const { versionKey, seenKey, skipAllKey } = getTeamStorageContext()
    const currentVersion = loadFromLocal(versionKey)

    if (currentVersion !== TUTORIAL_VERSION) {
      saveToLocal(versionKey, TUTORIAL_VERSION)
      saveToLocal(seenKey, {})
      saveToLocal(skipAllKey, false)
    }

    const isSkippedGlobally = loadFromLocal(skipAllKey) === true
    const seenMap = loadFromLocal(seenKey) || {}
    const shouldShow = !isSkippedGlobally && !Boolean(seenMap[pageKey])

    if (!shouldShow) {
      setShow(false)
      return undefined
    }

    const timer = window.setTimeout(() => setShow(true), SHOW_DELAY_MS)
    return () => window.clearTimeout(timer)
  }, [pageKey])

  const dismiss = useCallback(() => {
    if (!pageKey) return
    const { seenKey } = getTeamStorageContext()
    const currentSeen = loadFromLocal(seenKey) || {}
    saveToLocal(seenKey, { ...currentSeen, [pageKey]: true })
    setShow(false)
  }, [pageKey])

  const dismissAll = useCallback(() => {
    const { skipAllKey } = getTeamStorageContext()
    saveToLocal(skipAllKey, true)
    setShow(false)
  }, [])

  return { show, dismiss, dismissAll }
}
